(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pill-header"]) return;
  try {
    
  class PillHeaderComponent extends HTMLElement {
    connectedCallback() {
      // Standard-mode pages lock the pill in sticky styling; no scroll handling needed.
      if (this.dataset.pageMode === 'standard') return;

      this.threshold = parseInt(this.dataset.stickyThreshold || '120', 10);
      this.onScroll = () => {
        const scrolled = window.scrollY > this.threshold;
        this.setAttribute('data-sticky-state', scrolled ? 'active' : 'inactive');
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }
    disconnectedCallback() {
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
    }
  }
  if (!customElements.get('pill-header-component')) {
    customElements.define('pill-header-component', PillHeaderComponent);
  }

  } catch(e) { console.error(e); }
})();
})();
